export function getImagePath(relativePath) {
	// return require(`../../../assets/images${relativePath}`);
	// if (process.env.NODE_ENV === 'development') {
	return require(`assets/images${relativePath}`);
	// }
	// return `${process.env.REACT_APP_CDN_IMG_BASEPATH}${relativePath}`;
}
